import React from "react";
import {
  Filter, Loading, Tab, Typography,
} from "@kitbird/core";
import {
  CardContent, PageCard, PageWrapper, TitleContent,
} from "../../../components/Content/Content.style";
import { HeaderText } from "../../../components/FloatHeader/FloatHeader.style";
import BluebirdLogo from "../../../assets/icons/logogram_bb.png";
import { ReactComponent as FilterIcon } from "../../../assets/icons/filter.svg";
import { TabTypes } from "../../Transaction/CreateReceiptSubmission/enums";
import useApproval from "./hooks/useApprovalVendor";
import SearchInput from "../../../components/SearchInput";
import ApprovalVendorTable from "./components/ApprovalVendorTable";
import { StickyTable } from "../../../components/Table/Table.style";
import ModalApproval from "./components/ModalApproval";
import PageLoading from "../../../components/Loading/PageLoading";
import { tabOpts } from "./constants";
import { ActionSection } from "../../../components/Filter/Filter.style";

const ApprovalMasterVendor = () => {
  const useCustomHook = useApproval();
  const {
    columnOpts, setColumnOpts,
    searchText, setSearchText, params, setParams,
    isLoading,
    isFetching, isFetchingNextPage,
  } = useCustomHook;

  const tabComponent = <Tab
    onClickTab={(tabName) => setParams((curr) => ({ ...curr, status_approval: tabName }))}
    items={tabOpts}
    variant="fullWidth"
    active={tabOpts.findIndex((opt) => opt.name === params.status_approval)}
  />;

  const filtersComponent = <ActionSection style={{ justifyContent: "unset" }}>
    <SearchInput
      placeholder="Cari data"
      onChange={(e) => setSearchText(e.target.value)}
      value={searchText}
    />
    <Filter label="Kolom" options={columnOpts} onSelected={setColumnOpts} icon={<FilterIcon style={{ marginRight: 8 }} />} />
  </ActionSection>;

  return (<>
    <PageWrapper>
      <HeaderText>
        <Typography level={3} fontWeight="medium">Approval master vendor</Typography>
      </HeaderText>
      <PageCard>
        <CardContent>
          <TitleContent>
            <img src={BluebirdLogo} alt="" />
            <Typography level={4} fontWeight="medium">
              Daftar approval master vendor
            </Typography>
          </TitleContent>
          <div>
            {tabComponent}
            {filtersComponent}
          </div>
          <StickyTable>
            {isFetching && !isFetchingNextPage
              ? <Loading variant="line" />
              : <ApprovalVendorTable
                useCustomHook={useCustomHook}
              />
            }
          </StickyTable>
        </CardContent>
      </PageCard>
    </PageWrapper>
    <ModalApproval
      useCustomHook={useCustomHook}
    />
    {isLoading && (
      <PageLoading />
    )}
  </>);
};

export default ApprovalMasterVendor;
